/**
 * Nested overflow scroll plus window scroll. Does not include `el` itself, so
 * an inner chart/results scroller cannot change the Lab's fill height.
 */
export function overflowAncestorScrollY(el: HTMLElement): number {
  let y = 0;
  let node: HTMLElement | null = el.parentElement;
  while (node && node !== document.body && node !== document.documentElement) {
    y += node.scrollTop;
    node = node.parentElement;
  }
  return y + window.scrollY;
}

/**
 * Remaining viewport height below the element's layout top — the position as if
 * no ancestor had scrolled. Page scroll must not inflate the Lab.
 */
export function fillViewportHeightPx(el: HTMLElement, bottomPadPx: number): number {
  const restTop = Math.max(0, el.getBoundingClientRect().top + overflowAncestorScrollY(el));
  return Math.max(520, Math.round(window.innerHeight - restTop - bottomPadPx));
}
